import {
  SET_WHITE_INK_OPTIONS_NEEDED,
  SET_WHITE_INK_OPTIONS_NEXT_DISABLED,
  SET_INCLUDES_WHITE_UNDERPRINT,
  STATE_ARTWORK_PREVIEW,
  SET_ARTWORK_PREVIEW_ZOOM,
  SET_WHITE_INK_OPTION,
  SET_TOLERANCE,
  SET_ADVANCED_MODE_VISIBLE,
  SET_ADVANCED_MODE_TOLERANCE_SLIDER_ENABLED,
  SET_TOUCH_UP_MODE,
  SET_LAST_CLICK_COORDINATES,
  SET_DARK_MODE,
  RESET_WHITE_INK_OPTIONS_DATA,
} from './_types';

export const setWhiteInkOptionsNeeded = isNeeded => ({
  type: SET_WHITE_INK_OPTIONS_NEEDED,
  payload: isNeeded,
});

export const setWhiteInkOptionsNextDisabled = isDisabled => ({
  type: SET_WHITE_INK_OPTIONS_NEXT_DISABLED,
  payload: isDisabled,
});

export const setIncludesWhiteUnderprint = includesWhiteUnderPrint => ({
  type: SET_INCLUDES_WHITE_UNDERPRINT,
  payload: includesWhiteUnderPrint,
});

export const setWhiteInkOption = option => ({
  type: SET_WHITE_INK_OPTION,
  payload: option,
});

export const setTolerance = tolerance => ({
  type: SET_TOLERANCE,
  payload: tolerance,
});

export const stateArtworkPreview = artworkPreview => ({
  type: STATE_ARTWORK_PREVIEW,
  payload: artworkPreview,
});

export const setArtworkPreviewZoom = zoomValue => ({
  type: SET_ARTWORK_PREVIEW_ZOOM,
  payload: zoomValue,
});

export const setAdvancedModeVisible = isVisible => ({
  type: SET_ADVANCED_MODE_VISIBLE,
  payload: isVisible,
});

export const setAdvancedModeToleranceSliderEnabled = isEnabled => ({
  type: SET_ADVANCED_MODE_TOLERANCE_SLIDER_ENABLED,
  payload: isEnabled,
});

export const setTouchUpMode = mode => ({
  type: SET_TOUCH_UP_MODE,
  payload: mode,
});

export const setLastClickCoordinates = coordinates => ({
  type: SET_LAST_CLICK_COORDINATES,
  payload: coordinates,
});

export const setDarkMode = isDarkMode => ({
  type: SET_DARK_MODE,
  payload: isDarkMode,
});

export const resetWhiteInkOptionsData = () => ({
  type: RESET_WHITE_INK_OPTIONS_DATA,
});
